export enum SystemRole {
    Supervisor = 'supervisor',
    OpsStaff = 'ops-staff',
    Director = 'director',
    Adviser = 'adviser',
    Recruit = 'recruit',
    ProductAdmin = 'product-admin',
    BSCReviewer = 'bsc-reviewer',
    PTCOAdmin = 'ptco-admin'
}
